// opervex-frontend/src/routes/reportRoutes.js

import Stock from "../pages/Reports/Stock";
import StockSerial from "../pages/Reports/StockSerial";
import StockSerialDays from "../pages/Reports/StockSerialDays";
import GoodsMovement from "../pages/Reports/GoodsMovement";
import GoodsMovementFull from "../pages/Reports/GoodsMovementFull";
import ServiceOrder from "../pages/Reports/ServiceOrder";
import SalesOrder from "../pages/Reports/SalesOrder";

const reportRoutes = [
  { path: "Report/Stock", private: true, component: <Stock />, role: "REPORT_STOCK" },
  { path: "Report/StockSerial", private: true, component: <StockSerial />, role: "REPORT_STOCK_SERIAL" },
  { path: "Report/StockSerialDays", private: true, component: <StockSerialDays />, role: "REPORT_SERIAL_DAYS_DEPOSIT" },
  { path: "Report/GoodsMovement", private: true, component: <GoodsMovement />, role: "REPORT_GOODS_MOVEMENT" },
  { path: "Report/GoodsMovementFull", private: true, component: <GoodsMovementFull />, role: "REPORT_GOODS_MOVEMENT_FULL" },
  { path: "Report/ServiceOrder", private: true, component: <ServiceOrder />, role: "REPORT_SERVICE_ORDER", admin: true },
  { path: "Report/SalesOrder", private: true, component: <SalesOrder />, role: "REPORT_SALES_ORDER" },
];

export default reportRoutes;
